import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import deCommon from './locales/de/common.json';
import enCommon from './locales/en/common.json';
import deAudit from './locales/de/audit.json';
import enAudit from './locales/en/audit.json';

const resources = {
  de: {
    common: deCommon,
    audit: deAudit,
  },
  en: {
    common: enCommon,
    audit: enAudit,
  },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    lng: 'de',
    fallbackLng: 'de',
    supportedLngs: ['de', 'en'],
    defaultNS: 'common',
    ns: ['common', 'audit'],
    interpolation: {
      escapeValue: false,
    },
    detection: {
      order: ['localStorage'],
      lookupLocalStorage: 'i18nextLng',
      caches: ['localStorage'],
      convertDetectedLanguage: (lng: string) => {
        if (lng.startsWith('de')) return 'de';
        if (lng.startsWith('en')) return 'en';
        return 'de';
      },
    },
  });

export default i18n;
